import { APIClient } from '@frontend/api-utils';
import {
    CustomRoleTemplate,
    EntityTypePermissionTemplate,
    PossibleRolesTemplate,
    PredefinedPermissionTemplate,
    PredefinedRoleTemplate
} from '@frontend/role/types';

export class RoleTemplateClient extends APIClient {
    public static readonly endpoint = '/authorization-api/v1';

    public static async fetchPredefinedRoleTemplates(): Promise<PredefinedRoleTemplate> {
        const response = await this.fetch(`${this.endpoint}/predefined-role-templates`);
        return await this.handleResponse<any>(response);
    }

    public static async fetchPredefinedPermissionTemplates(): Promise<PredefinedPermissionTemplate> {
        const response = await this.fetch(`${this.endpoint}/predefined-permission-templates`);
        return await this.handleResponse<any>(response);
    }

    public static async fetchCustomRoleTemplates(): Promise<CustomRoleTemplate> {
        const response = await this.fetch(`${this.endpoint}/custom-role-templates`);
        return await this.handleResponse<any>(response);
    }

    public static async fetchEntityTypePermissions(): Promise<EntityTypePermissionTemplate> {
        const response = await this.fetch(`${this.endpoint}/entity-type-permissions`);
        return await this.handleResponse<EntityTypePermissionTemplate>(response);
    }

    public static async fetchPossibleRoles(accountId: string, entityType: string): Promise<PossibleRolesTemplate> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/${entityType}s/possible-roles`);
        return await this.handleResponse<PossibleRolesTemplate>(response);
    }
}
